module.exports = __webpack_public_path__ + "img/icon-location.462b17ff.svg";